import storage from './storage';
import { generateId } from '../utils/uuid';
import { TEAM_KEYS, migratePrivateBucketsToTeam } from '../utils/teamCrmStore';

function key() {
  return TEAM_KEYS.leads;
}

export const contactService = {
  getAll(_userId) {
    void _userId;
    migratePrivateBucketsToTeam();
    return storage.get(key(), []);
  },

  saveAll(_userId, contacts) {
    void _userId;
    storage.set(key(), contacts);
  },

  /** Creates a contact with proper metadata fields. Returns the new contact. */
  create(data, userId) {
    const all = this.getAll();
    const contact = {
      ...data,
      id: generateId(),
      ownerId: userId || data.ownerId || null,
      companyId: data.companyId || null,
      parentLeadId: data.parentLeadId ?? null,
      pipelineId: data.pipelineId || 'new_business',
      source: data.source || '',
      offerLineItems: Array.isArray(data.offerLineItems) ? data.offerLineItems : [],
      tags: data.tags || [],
      createdAt: data.createdAt || new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    };
    this.saveAll(null, [contact, ...all]);
    return contact;
  },

  update(id, changes, _userId) {
    void _userId;
    const all = this.getAll();
    const updated = all.map(c =>
      c.id === id ? { ...c, ...changes, updatedAt: new Date().toISOString() } : c
    );
    this.saveAll(null, updated);
    return updated.find(c => c.id === id) || null;
  },

  remove(id, _userId) {
    void _userId;
    const all = this.getAll();
    const contact = all.find(c => c.id === id) || null;
    this.saveAll(null, all.filter(c => c.id !== id));
    return contact;
  },

  findById(id, _userId) {
    void _userId;
    return this.getAll().find(c => c.id === id) || null;
  },
};
